import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=266ed1c0&scoped=true&"
import script from "./PrivacyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=266ed1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ed1c0",
  null
  
)

export default component.exports